import { cn } from '@/lib/utils';
import type { TableCellProps } from './types';

/**
 * Base TableCell component with shared visual styles.
 * Uses group-focus: to inherit focus state from the parent positioned wrapper.
 */
export function TableCell({
  children,
  className,
  style,
  isEditing,
  isDisabled,
  onDoubleClick,
  onKeyDown,
}: TableCellProps) {
  return (
    <div
      className={cn(
        'flex min-h-10 flex-none items-center border border-transparent border-r-primary-5 border-b-primary-5 bg-white px-3 font-medium text-primary text-s',
        isDisabled
          ? 'group-focus-within:rounded-xs group-focus-within:border-primary-40 group-focus-within:bg-primary-3 group-focus:rounded-xs group-focus:border-primary-40 group-focus:bg-primary-3'
          : 'group-focus-within:rounded-xs group-focus-within:border-highlight-default group-focus-within:bg-highlight-light group-focus:rounded-xs group-focus:border-highlight-default group-focus:bg-highlight-light',
        isEditing && 'rounded-xs border-highlight-default',
        className,
      )}
      style={style}
      onDoubleClick={onDoubleClick}
      onKeyDown={onKeyDown}
    >
      {children}
    </div>
  );
}
